__turbopack_context__.v({
  "caption": "features-module-scss-module__a7z71q__caption",
  "content": "features-module-scss-module__a7z71q__content",
  "feature": "features-module-scss-module__a7z71q__feature",
  "featureGroup": "features-module-scss-module__a7z71q__featureGroup",
  "featureGroupWrp": "features-module-scss-module__a7z71q__featureGroupWrp",
  "featureText": "features-module-scss-module__a7z71q__featureText",
  "featureTitle": "features-module-scss-module__a7z71q__featureTitle",
  "subtitle": "features-module-scss-module__a7z71q__subtitle",
  "title": "features-module-scss-module__a7z71q__title",
});
